import React from 'react';
// styles
import styled from 'styled-components';

const LeafIcon = ({ className, ...props }) => (
  <svg
    {...props}
    width="16"
    height="14"
    viewBox="0 0 16 14"
    xmlns="http://www.w3.org/2000/svg"
    role="img"
    aria-label="Leaf"
    className={className}
  >
    <path d="M15.8241 1.10673C15.7861 0.88111 15.6358 0.69037 15.4253 0.600648C15.2149 0.510926 14.9732 0.534577 14.7841 0.663401C13.2505 1.59893 11.471 2.05165 9.67677 1.96273C5.55744 1.96273 3.8381 3.64207 3.80544 3.68073C1.82301 5.14199 1.0885 7.76433 2.02344 10.0427C2.07325 10.1642 2.04715 10.3035 1.95677 10.3987L0.178103 12.3247C-0.0599281 12.5825 -0.0592918 12.9801 0.179563 13.2372C0.418418 13.4942 0.814916 13.5239 1.08944 13.3054C2.23344 12.2661 4.09944 9.13274 9.34544 6.94007C9.68662 6.80084 10.0763 6.96266 10.2184 7.30263C10.3606 7.6426 10.2022 8.03363 9.86344 8.17873C7.76905 9.03581 5.86038 10.2902 4.24277 11.8727L4.23677 11.8794L4.0821 12.0467C4.01317 12.1195 3.98066 12.2195 3.99359 12.3189C4.00652 12.4183 4.06351 12.5067 4.14877 12.5594C5.00029 13.0931 5.98514 13.3757 6.9901 13.3747C8.3426 13.3509 9.66785 12.9905 10.8461 12.3261C16.6921 9.11007 16.1328 2.9254 15.8241 1.10673Z" />
  </svg>
);

export default styled(LeafIcon)``;
